<app-pageheader [Parent]="this">
  <app-form-save-button [Parent]="this" [Form]="citationForm" class="button is-primary" (OnSave)="save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>

@if (!IsLoading) {
  <div [formGroup]="citationForm">
    <div class="columns">
      <!-- Left Column - Citation Details -->
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            <span>Citation Details</span>
          </p>
          <div class="panel-block is-block">
            <app-field Label="Reference (optional)">
              <div class="control">
                <input formControlName="Reference" class="input" type="text" placeholder="(optional)" />
              </div>
            </app-field>
            <app-field Label="Issue Date">
              <div class="control">
                <input formControlName="IssuedDate" class="input" type="datetime-local" />
              </div>
            </app-field>
            <app-field Label="Issuing Officer *">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="OfficerId">
                    <option [ngValue]="null" disabled>Select an officer...</option>
                    @for (officer of officers; track officer) {
                      <option [ngValue]="officer.Id">
                        {{ officer.UserName || officer.UserEmail }} {{ officer.BadgeNumber ? '(' + officer.BadgeNumber + ')' : '' }}
                      </option>
                    }
                  </select>
                </div>
                <app-validator [For]="citationForm.get('OfficerId')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Warning">
              <div class="control">
                <div class="field">
                  <label class="checkbox">
                    <input type="checkbox" formControlName="IsWarning" />
                    Issue as Warning (no fee)
                  </label>
                </div>
              </div>
            </app-field>
            <app-field Label="Notes">
              <div class="control">
                <textarea formControlName="Notes" class="textarea" rows="3" placeholder="Optional notes about this citation"></textarea>
              </div>
            </app-field>
            <app-field Label="Contact Email">
              <div class="control">
                <input formControlName="EmailAddress" class="input" type="email" placeholder="Optional email address" />
                <app-validator [For]="citationForm.get('EmailAddress')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
        <!-- Vehicle Details -->
        <article class="panel">
          <p class="panel-heading">
            <span>Vehicle Details</span>
          </p>
          <div class="panel-block is-block">
            <app-field Label="Plate Number *">
              <div class="control">
                <input formControlName="PlateNumber" class="input" type="text" placeholder="Enter plate number"
                  style="text-transform: uppercase;" />
                  <app-validator [For]="citationForm.get('PlateNumber')"></app-validator>
                </div>
              </app-field>
              <app-field Label="Vehicle Make">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="VehicleBrandId">
                      <option [ngValue]="null">Select make (optional)...</option>
                      @for (make of vehicleMakes; track make) {
                        <option [ngValue]="make.Id">{{ make.Name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
              <app-field Label="Vehicle Color">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="VehicleColorId">
                      <option [ngValue]="null">Select color (optional)...</option>
                      @for (color of vehicleColors; track color) {
                        <option [ngValue]="color.Id">{{ color.Name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
            </div>
          </article>
          <!-- Location Details -->
          <article class="panel">
            <p class="panel-heading">
              <span>Location Details</span>
            </p>
            <div class="panel-block is-block">
              <app-field Label="Parking Lot">
                <div class="control">
                  <div class="field has-addons">
                    <div class="control is-expanded">
                      <input class="input" type="text" [value]="selectedParkingLot?.Name || ''" readonly placeholder="Select a parking lot (optional)..." />
                    </div>
                    <div class="control">
                      <button class="button" type="button" (click)="openParkingLotSelector()">
                        <span class="icon"><i class="fas fa-search"></i></span>
                      </button>
                    </div>
                    @if (selectedParkingLot) {
                      <div class="control">
                        <button class="button is-danger is-light" type="button" (click)="clearParkingLot()">
                          <span class="icon"><i class="fas fa-times"></i></span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </app-field>
              <app-field Label="Parking Space">
                <div class="control">
                  <input formControlName="ParkingSpaceName" class="input" type="text" placeholder="Enter space name/number (optional)..." />
                </div>
              </app-field>
            </div>
          </article>
        </div>
        <!-- Right Column - Infringement Types & Media -->
        <div class="column is-6">
          <!-- Infringement Types Selection -->
          <article class="panel">
            <p class="panel-heading">
              <span>Infringement Types *</span>
            </p>
            <div class="panel-block is-block">
              <p class="mb-3 has-text-grey is-size-7">Select one or more infringement types for this citation:</p>
              <div class="infringement-types-list">
                @for (infType of infringementTypes; track infType) {
                  <div
                    class="infringement-type-item"
                    [class.selected]="isInfringementTypeSelected(infType)"
                    (click)="toggleInfringementType(infType)">
                    <div class="infringement-type-checkbox">
                      @if (isInfringementTypeSelected(infType)) {
                        <span class="icon">
                          <i class="fas fa-check-square"></i>
                        </span>
                      }
                      @if (!isInfringementTypeSelected(infType)) {
                        <span class="icon">
                          <i class="far fa-square"></i>
                        </span>
                      }
                    </div>
                    <div class="infringement-type-details">
                      <div class="infringement-type-name">{{ infType.Name }}</div>
                      @if (infType.Description) {
                        <div class="infringement-type-description">{{ infType.Description }}</div>
                      }
                    </div>
                    <div class="infringement-type-fee">
                      <span class="tag" [ngClass]="citationForm.get('IsWarning')?.value ? 'is-light' : 'is-warning'">
                        {{ citationForm.get('IsWarning')?.value ? '$0.00' : ('$' + (infType.BaseFine | number:'1.2-2')) }}
                      </span>
                    </div>
                  </div>
                }
              </div>
              @if (selectedInfringementTypes.length === 0) {
                <div class="notification is-warning is-light mt-3">
                  <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
                  <span>Please select at least one infringement type.</span>
                </div>
              }
              @if (selectedInfringementTypes.length > 0) {
                <div class="total-fee-display mt-4">
                  <div class="level">
                    <div class="level-left">
                      <div class="level-item">
                        <span class="has-text-weight-bold">Total Fee:</span>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <span class="tag is-large" [ngClass]="citationForm.get('IsWarning')?.value ? 'is-success' : 'is-danger'">
                          {{ citationForm.get('IsWarning')?.value ? 'Warning - No Fee' : ('$' + (getTotalFee() | number:'1.2-2')) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </article>
          <!-- Media Upload -->
          <article class="panel">
            <p class="panel-heading">
              <span class="icon"><i class="fas fa-camera"></i></span>
              <span>Evidence Images</span>
            </p>
            <div class="panel-block is-block">
              <div class="file-drop-zone"
                [class.is-dragging]="isDragging"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)">
                <div class="file-drop-content">
                  <span class="icon is-large has-text-grey-light">
                    <i class="fas fa-cloud-upload-alt fa-3x"></i>
                  </span>
                  <p class="mt-2">Drag and drop images here</p>
                  <p class="has-text-grey is-size-7">or</p>
                  <div class="file is-info is-boxed mt-2">
                    <label class="file-label">
                      <input class="file-input" type="file" accept="image/*" multiple (change)="onFileSelected($event)" />
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose files</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              @if (uploadingFile) {
                <div class="has-text-centered mt-3">
                  <span class="icon"><i class="fas fa-spinner fa-spin"></i></span>
                  <span>Uploading...</span>
                </div>
              }
              @if (uploadedMediaIds.length > 0) {
                <div class="uploaded-media-list mt-4">
                  <p class="has-text-grey is-size-7 mb-2">Uploaded images:</p>
                  <div class="tags">
                    @for (mediaId of uploadedMediaIds; track mediaId; let i = $index) {
                      <span class="tag is-info is-medium">
                        <span class="icon"><i class="fas fa-image"></i></span>
                        <span>Image #{{ i + 1 }}</span>
                        <button class="delete is-small" type="button" (click)="removeMedia(i)"></button>
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </article>
        </div>
      </div>
    </div>
  }

